import * as React from 'react';
import { CoreButtonNext as ButtonNext } from '../internal/WixUiCoreComponents/components/CoreButtonNext';
import { Text } from '../Text';
import { EVENT_DATA_KEYS } from './dataHooks';
import { st, classes } from './Event.st.css';
import { EventDefaultProps, EventProps } from './types';

/** Event */
export class Event extends React.Component<EventProps> {
  static displayName = 'Event';
  static defaultProps: EventDefaultProps = {
    showTime: true,
    fullday: false,
    selected: false,
    disabled: false,
    onClick: null,
    'aria-has-popup': false,
    'aria-expanded': false,
  };

  getDataAttributes() {
    const { fullday, selected, showTime } = this.props;

    return {
      [EVENT_DATA_KEYS.IsFullDay]: fullday,
      [EVENT_DATA_KEYS.IsSelected]: selected,
      [EVENT_DATA_KEYS.IsTimeShown]: showTime,
    };
  }

  _getEventProps = (isContainer) =>
    isContainer
      ? {
          'data-hook': this.props['data-hook'],
          ...this.getDataAttributes(),
          [EVENT_DATA_KEYS.ARIA_Has_Popup]: this.props['aria-has-popup'],
          [EVENT_DATA_KEYS.ARIA_Expanded]: this.props['aria-expanded'],
        }
      : null;

  _getEvent = (isContainer, className, timeComponent, title) => (
    <div
      {...this._getEventProps(isContainer)}
      className={st(
        classes.root,
        { fullday: this.props.fullday, selected: this.props.selected },
        className,
      )}
    >
      {timeComponent}
      <Text className={classes.title}>{title}</Text>
      <div className={classes.overlay} />
    </div>
  );

  render() {
    const { time, title, showTime, className, onClick, disabled } = this.props;
    const timeComponent =
      showTime && time ? <Text className={classes.time}>{time}</Text> : null;

    return onClick ? (
      <ButtonNext
        disabled={disabled}
        onClick={() => !disabled && onClick()}
        className={st(classes.buttonContainer)}
        {...this._getEventProps(true)}
      >
        {this._getEvent(false, className, timeComponent, title)}
      </ButtonNext>
    ) : (
      this._getEvent(true, className, timeComponent, title)
    );
  }
}
